import React, { useState, useEffect, Fragment, useRef } from 'react'
import { reduxForm, FieldArray } from 'redux-form'
import { Card, Col, Row } from 'react-bootstrap'
import { Button } from "@material-ui/core"
import SignatureCanvas from "react-signature-canvas";
import { InputField, DropdownField } from 'components/forms/reduxForm'
import CheckBox from 'components/forms/Checkbox'
import {
  statesOptions,
  countryOptions
} from 'constants/constantVariables'
import { DemoModeApplicationValues } from 'constants/application'
import {
  phoneNumberValidation,
  validateEmail,
} from 'tools/forms/validators'
import {
  removeBlanks
} from 'tools/forms/normalizers'
import {
  GOOGLE_MAP_API_KEY,
  RECAPTCHA_SITE_KEY
} from 'constants/config'
import SearchMyAdressComponent from 'components/shared/searchMyAddressInput'
import strings from 'strings'
import { useAppContext } from '../../context/AppContext'
import FileUploader from 'components/shared/FileUploader'
import { Toast } from 'components/shared/Toaster';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import { Remove, Add } from '@material-ui/icons'
import { LoadScript } from "@react-google-maps/api";
import Loader from 'components/shared/Loader'
import { Helmet } from 'react-helmet';
import './invoiceSubmission.scss'


const largeDropdownStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: 48,
    fontSize: '1.15rem',
    paddingLeft: 12,
    paddingRight: 12,
  }),
  input: (provided) => ({
    ...provided,
    fontSize: '1.15rem',
    minHeight: 48,
    display: 'flex',
    alignItems: 'center'
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '1.15rem',
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: 212,
    background: '#fff',
    zIndex: "10!important",
  }),
};

const RenderBusiness = (props) => {
  const {
    change,
  } = props

  const [stateOptions, setStateOptions] = useState([statesOptions.USA]);
  const [addAddressManually, setAddAddressManually] = useState(false);

  const handleCountryChange = (selectedCountry) => {
    change(`businessState`, '')
    setStateOptions(prev => {
      const newStateOptions = [...prev]
      newStateOptions[0] = statesOptions[selectedCountry];
      return newStateOptions;
    })
  };

  const handleBusinessAddressChange = (address) => {
    if (!address) {
      change(`businessAddress1`, '');
      return
    }
    if (!address?.zipCode) {
      setAddAddressManually(true)
      Toast({ type: 'warning', message: strings.ZIPCODE_NOT_FOUND });
      return
    }
    change(`businessAddress2`, address.address2);
    change(`businessCity`, address.city);
    change(`businessState`, address.state);
    change(`businessZip5`, address.zipCode);
    change(`businessCountryCode`, address.country);
  }

  const handleAddressManually = (bool) => {
    change(`businessAddress1`, '');
    change(`businessAddress2`, '');
    change(`businessCity`, '');
    change(`businessState`, '');
    change(`businessZip5`, '');
    change(`businessCountryCode`, '');
    setAddAddressManually(bool);
  }

  return (
    <Row>
      <Col md={4}>
        <InputField
          name={`businessName`}
          label={strings.BUSINESS_NAME}
          required
          indicateRequired
          id='businessName'
          inputClassName="custom-input"
          style={{ fontSize: '1.15rem', minHeight: '48px' }}
        />
      </Col>
      <Col md={4}>
        <InputField
          name={`businessDbaName`}
          label={strings.BUSINESS_DBA_NAME}
          inputClassName="custom-input"
          required
          indicateRequired
          style={{ fontSize: '1.15rem', minHeight: '48px' }}
        />
      </Col>
      <Col md={4}>
        <InputField
          name={`federalTaxId`}
          label="Federal Tax ID#"
          inputClassName="custom-input"
          required
          indicateRequired
          style={{ fontSize: '1.15rem', minHeight: '48px' }}
        />
      </Col>
      <Col md={4}>
        <InputField
          name={`referredBy`}
          label="Referred by"
          inputClassName="custom-input"
          style={{ fontSize: '1.15rem', minHeight: '48px' }}
        />
      </Col>
      <Col md={4}>
        <InputField
          name={`businessStartDate`}
          label={strings.BUSINESS_START_DATE}
          type='date'
          inputClassName="custom-input"
          style={{ fontSize: '1.15rem', minHeight: '48px' }}
          InputLabelProps={{ shrink: true }}
          required
          indicateRequired
        />
      </Col>
      <Col md={4}>
        {!addAddressManually ? (
          <SearchMyAdressComponent
            label={strings.BUSINESS_ADDRESS}
            name="businessAddress1"
            customAddress1="addressLine1"
            customAddress2="addressLine2"
            customCity="billingUserCity"
            customState="billingUserState"
            customZipCode="zipCode"
            handleAddressChange={handleBusinessAddressChange}
            id='businessName-address1'
            inputClassName="custom-input search-input"
            style={{ fontSize: '1.15rem', minHeight: '48px' }}
            indicateRequired
            required
          />
        ) : (
          <>
            <InputField
              name={`businessAddress1`}
              label={strings.BUSINESS_ADDRESS_LINE_1}
              required
              indicateRequired
              id='businessName-address1'
              inputClassName="custom-input"
              style={{ fontSize: '1.15rem', minHeight: '48px' }}
            />
          </>
        )}
        <CheckBox
          checked={addAddressManually}
          onChange={handleAddressManually}
          label={strings.ADD_ADDRESS_MANUALLY}
          style={{ marginTop: 8 }}
        />
      </Col>
      {addAddressManually && (
        <>
          <Col md={4}>
            <InputField
              name={`businessAddress2`}
              label={strings.BUSINESS_ADDRESS_LINE_2}
              id='businessName'
              inputClassName="custom-input"
              style={{ fontSize: '1.15rem', minHeight: '48px' }}
            />
          </Col>
          <Col md={4}>
            <InputField
              name={`businessZip5`}
              label={strings.ZIPCODE}
              required
              indicateRequired
              inputClassName="custom-input"
              style={{ fontSize: '1.15rem', minHeight: '48px' }}
            />
          </Col>
          <Col md={4}>
            <InputField
              name={`businessCity`}
              label={strings.CITY}
              required
              indicateRequired
              inputClassName="custom-input"
              style={{ fontSize: '1.15rem', minHeight: '48px' }}
            />
          </Col>
          <Col md={4}>
            <DropdownField
              name={`businessCountryCode`}
              label={strings.COUNTRY}
              options={countryOptions}
              required
              isSearchable
              onChange={country => handleCountryChange(country)}
              id='ownerCountryCode'
              propStyles={largeDropdownStyles}
              className="menu-list-index"
            />
          </Col>
          <Col md={4}>
            <DropdownField
              name={`businessState`}
              label={strings.STATE}
              options={stateOptions[0]}
              required
              isSearchable
              id='ownerState'
              propStyles={largeDropdownStyles}
              className="menu-list-index"
            />
          </Col>
        </>
      )}
    </Row>
  )
}

// RenderOwnersFieldArray: FieldArray version for InvoiceSubmission with add/remove icons and default 1 owner
const RenderOwnersFieldArray = ({ fields, change, formValues }) => {
  const { isDemoMode } = useAppContext();
  const [stateOptions, setStateOptions] = useState([statesOptions.USA, statesOptions.USA, statesOptions.USA]);
  const [addAddressManually, setAddAddressManually] = useState([false, false, false]);
  const [useBusinessAddress, setUseBusinessAddress] = useState([false, false, false]);
  const signatureRefs = useRef([]);

  // Show one owner by default
  useEffect(() => {
    if (fields.length === 0) {
      fields.push({});
    }
  }, [fields]);

  const handleCountryChange = (selectedCountry, index) => {
    change(`${fields.name}[${index}].ownerState`, '');
    setStateOptions(prev => {
      const newStateOptions = [...prev];
      newStateOptions[index] = statesOptions[selectedCountry];
      return newStateOptions;
    });
  };

  const handleOwnerAddressChange = (address, index) => {
    if (!address) {
      change(`${fields.name}[${index}].address1`, '');
      return;
    }
    if (!address?.zipCode) {
      setAddAddressManually(prev => {
        const arr = [...prev];
        arr[index] = true;
        return arr;
      });
      Toast({ type: 'warning', message: strings.ZIPCODE_NOT_FOUND });
      return;
    }
    change(`${fields.name}[${index}].address2`, address.address2);
    change(`${fields.name}[${index}].city`, address.city);
    change(`${fields.name}[${index}].state`, address.state);
    change(`${fields.name}[${index}].zip5`, address.zipCode);
    change(`${fields.name}[${index}].countryCode`, address.country);
  };

  const handleAddressManually = (bool, index) => {
    change(`${fields.name}[${index}].address1`, '');
    change(`${fields.name}[${index}].address2`, '');
    change(`${fields.name}[${index}].city`, '');
    change(`${fields.name}[${index}].state`, '');
    change(`${fields.name}[${index}].zip5`, '');
    change(`${fields.name}[${index}].countryCode`, '');
    setAddAddressManually(prev => {
      const arr = [...prev];
      arr[index] = bool;
      return arr;
    });
  };

  const handleAddOwner = () => {
    if (fields.length < 2) {
      fields.push({});
    }
  };

  const handleRemoveOwner = (index) => {
    fields.remove(index);
    signatureRefs.current.splice(index, 1);
  };

  // Helper to copy business address to owner
  const copyBusinessAddressToOwner = (index) => {
    console.log('index', formValues, fields)
    if (!formValues || !formValues.businessAddress1) return;
    change(`${fields.name}[${index}].address1`, formValues.businessAddress1 || '');
    change(`${fields.name}[${index}].address2`, formValues.businessAddress2 || '');
    change(`${fields.name}[${index}].city`, formValues.businessCity || '');
    change(`${fields.name}[${index}].state`, formValues.businessState || '');
    change(`${fields.name}[${index}].zip5`, formValues.businessZip5 || '');
    change(`${fields.name}[${index}].countryCode`, formValues.businessCountryCode || '');
  };

  return (
    <>
      {fields.map((owner, index) => (
        <Fragment key={index}>
          <Row className="align-items-center mb-2 mt-2">
            <Col>
              <strong>{`${strings.OWNER_INFORMATION} ${index + 1}`}</strong>
            </Col>
            <Col xs="auto" className="d-flex justify-content-end align-items-center">
              <CheckBox
                checked={useBusinessAddress[index] || false}
                onChange={checked => {
                  setUseBusinessAddress(prev => {
                    const arr = [...prev];
                    arr[index] = checked;
                    return arr;
                  });
                  if (checked) {
                    copyBusinessAddressToOwner(index);
                  }
                }}
                label="Use address from business"
                style={{ marginRight: 12, marginBottom: 0 }}
              />
              {(fields.length > 1) && (
                <Remove className="mr-2 icon" onClick={() => handleRemoveOwner(index)} style={{ cursor: 'pointer' }} />
              )}
              {fields.length < 2 && index === fields.length - 1 && (
                <Add className="icon" onClick={handleAddOwner} style={{ cursor: 'pointer' }} />
              )}
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <InputField
                name={`${owner}.firstName`}
                label={strings.FIRST_NAME}
                disabled={isDemoMode}
                required
                indicateRequired
                inputClassName="custom-input"
                style={{ fontSize: '1.15rem', minHeight: '48px' }}
              />
            </Col>
            <Col md={4}>
              <InputField
                name={`${owner}.lastName`}
                label={strings.LAST_NAME}
                disabled={isDemoMode}
                required
                indicateRequired
                inputClassName="custom-input"
                style={{ fontSize: '1.15rem', minHeight: '48px' }}
              />
            </Col>
            <Col md={4}>
              <InputField
                name={`${owner}.email`}
                label={strings.EMAIL}
                validate={validateEmail}
                normalize={removeBlanks}
                required
                indicateRequired
                inputClassName="custom-input"
                style={{ fontSize: '1.15rem', minHeight: '48px' }}
              />
            </Col>
            <Col md={4}>
              <InputField
                name={`${owner}.phoneNumber`}
                label={strings.PHONE}
                validate={phoneNumberValidation}
                required
                isphoneNumber
                indicateRequired
                inputClassName="custom-input"
                style={{ fontSize: '1.15rem', minHeight: '48px' }}
              />
            </Col>
            <Col md={4}>
              <InputField
                name={`${owner}.dateOfBirth`}
                label={strings.DATE_OF_BIRTH}
                type='date'
                required
                indicateRequired
                inputClassName="custom-input"
                style={{ fontSize: '1.15rem', minHeight: '48px' }}
                InputLabelProps={{ shrink: true }}
              />
            </Col>
            <Col md={4}>
              <InputField
                name={`${owner}.socialSecurityNumber`}
                label={strings.SOCIAL_SECURITY_NUMBER}
                required
                indicateRequired
                inputClassName="custom-input"
                style={{ fontSize: '1.15rem', minHeight: '48px' }}
              />
            </Col>
            <Col md={4}>
              {!addAddressManually[index] ? (
                <SearchMyAdressComponent
                  label={strings.ADDRESS}
                  name={`${owner}.address1`}
                  inputClassName="custom-input search-input"
                  style={{ fontSize: '1.15rem', minHeight: '48px' }}
                  handleAddressChange={address => handleOwnerAddressChange(address, index)}
                  indicateRequired
                  required
                />
              ) : (
                <InputField
                  name={`${owner}.address1`}
                  label={strings.ADDRESS_1}
                  required
                  indicateRequired
                  inputClassName="custom-input"
                  style={{ fontSize: '1.15rem', minHeight: '48px' }}
                />
              )}
              <CheckBox
                checked={addAddressManually[index]}
                onChange={bool => handleAddressManually(bool, index)}
                label={strings.ADD_ADDRESS_MANUALLY}
                style={{ marginTop: 8 }}
              />
            </Col>
            {addAddressManually[index] && (
              <>
                <Col md={4}>
                  <InputField
                    name={`${owner}.address2`}
                    label={strings.ADDRESS_2}
                    inputClassName="custom-input"
                    style={{ fontSize: '1.15rem', minHeight: '48px' }}
                  />
                </Col>
                <Col md={4}>
                  <InputField
                    name={`${owner}.city`}
                    label={strings.CITY}
                    required
                    indicateRequired
                    inputClassName="custom-input"
                    style={{ fontSize: '1.15rem', minHeight: '48px' }}
                  />
                </Col>
                <Col md={4}>
                  <InputField
                    name={`${owner}.zip5`}
                    label={strings.ZIPCODE}
                    required
                    indicateRequired
                    inputClassName="custom-input"
                    style={{ fontSize: '1.15rem', minHeight: '48px' }}
                  />
                </Col>
                <Col md={4}>
                  <DropdownField
                    name={`${owner}.countryCode`}
                    label={strings.COUNTRY}
                    options={countryOptions}
                    required
                    isSearchable
                    onChange={country => handleCountryChange(country, index)}
                    id='ownerCountryCode'
                    propStyles={largeDropdownStyles}
                    className="menu-list-index"
                  />
                </Col>
                <Col md={4}>
                  <DropdownField
                    name={`${owner}.state`}
                    label={strings.STATE}
                    options={stateOptions[index]}
                    required
                    isSearchable
                    id='ownerState'
                    propStyles={largeDropdownStyles}
                    className="menu-list-index"
                  />
                </Col>
              </>
            )}
          </Row>
        </Fragment>
      ))}
    </>
  );
};

const InvoiceSubmission = (props) => {
  const {
    getFmcsaData,
    handleSubmit,
    reset,
    codeType,
    codeValue,
    change,
    hideFmcsa,
    showFactorCloudOnboardCheckbox,
    verifyRecaptchaToken,
    submitExternalApplication,
    fetchClientFormConfig,
    clientFormConfig,
  } = props

  useEffect(() => {
    const subdomain = window.location.hostname.split('.')[0];
    fetchClientFormConfig(subdomain);
  }, [fetchClientFormConfig]);

  const [formLoader, setFormLoader] = useState(false)
  const { isDemoMode } = useAppContext()
  const initialIsDemoMode = useRef(isDemoMode)
  const [stateOfFCOnboardCheckBox, setStateOfFCOnboardCheckBox] = useState(true)
  const [applicationType, setApplicationType] = useState('')
  const [selectedFiles, setSelectedFiles] = useState([])
  const [acceptTerms, setAcceptTerms] = useState(false);
  let sigCanvas = useRef(null);
  const [canvasWidth, setCanvasWidth] = useState(800);
  const canvasHeight = 300;
  const containerRef = useRef(null);
  const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB
  const signatureRefs = useRef([]);


  useEffect(() => {
    const updateCanvasWidth = () => {
      if (containerRef.current && containerRef.current.offsetWidth) {
        setCanvasWidth(containerRef.current.offsetWidth);
      }
    };
    // Try multiple times to ensure DOM is ready
    const timeouts = [0, 100, 250, 500];
    timeouts.forEach(t => setTimeout(updateCanvasWidth, t));
    window.addEventListener('resize', updateCanvasWidth);
    return () => window.removeEventListener('resize', updateCanvasWidth);
  }, []);


  useEffect(() => {
    if (isDemoMode !== initialIsDemoMode.current) {
      setFormLoader(true)
      window.location.reload()
    }
    if (isDemoMode) {
      const isDebtor = applicationType === "Debtor";

      const demoValues = isDebtor
        ? DemoModeApplicationValues.debtor
        : DemoModeApplicationValues.client;

      change('business', demoValues.business);

      if (!isDebtor) {
        change('owners', demoValues.owners);
        change('debtor', demoValues.debtor);
      }
    }
    // eslint-disable-next-line
  }, [isDemoMode, applicationType])


  useEffect(() => {
    if (codeType && codeValue) {
      setFormLoader(true)
      getFmcsaData({ codeType, codeValue }, isDemoMode).finally(() => {
        setFormLoader(false)
        if (isDemoMode) {
          const isDebtor = applicationType === "Debtor";

          const demoValues = isDebtor
            ? DemoModeApplicationValues.debtor
            : DemoModeApplicationValues.client;

          change('business', demoValues.business);

          if (!isDebtor) {
            change('owners', demoValues.owners);
            change('debtor', demoValues.debtor);
          }
        }
      })
    }
    // eslint-disable-next-line
  }, [getFmcsaData, codeType, codeValue])


  useEffect(() => {
    // Dynamically load the reCAPTCHA v3 script
    if (!window.grecaptcha) {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const handleRecaptchaAndSubmit = async (formValues) => {
    // Validate all owner signatures
    if (!formValues.owners || formValues.owners.length === 0) {
      Toast({ type: 'error', message: strings.AT_LEAST_ONE_OWNER });
      return;
    }
    for (let i = 0; i < formValues.owners.length; i++) {
      if (!signatureRefs.current[i] || signatureRefs.current[i].isEmpty()) {
        Toast({ type: 'error', message: strings.SIGNATURE_REQUIRED_FOR_OWNER(i) });
        return;
      }
    }
    // Collect signatures
    const ownersWithSignatures = formValues.owners.map((owner, i) => ({
      ...owner,
      signatureBase64: signatureRefs.current[i]?.toDataURL() || ''
    }));
    signatureRefs.current.forEach(sig => sig && sig.clear());
    setFormLoader(true)
    if (window.grecaptcha) {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' }).then(async (token) => {
          const verifyResult = await verifyRecaptchaToken(token);
          if (verifyResult?.valid) {
            const payload = {
              ...formValues,
              owners: ownersWithSignatures,
              invoiceBase64: '',
              recaptchaToken: token,
              subdomain: window.location.hostname.split('.')[0],
            };
            if (selectedFiles.length > 0) {
              const file = selectedFiles[0];
              const base64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
              });
              payload.invoiceBase64 = base64;
            }
            try {
              const response = await submitExternalApplication(payload);
              setFormLoader(false);
              if (response) {
                Toast({ type: 'info', message: strings.APPLICATION_SUBMITTED });
                reset();
                setSelectedFiles([]);
                setAcceptTerms(false);
                signatureRefs.current = [];
              }
            } catch (error) {
              setFormLoader(false);
              Toast({ type: 'error', message: strings.SUBMISSION_FAILED });
            }
          } else {
            setFormLoader(false);
            Toast({ type: 'error', message: strings.RECAPTCHA_FAILED });
          }
        }).catch(() => {
          setFormLoader(false);
          Toast({ type: 'error', message: strings.RECAPTCHA_FAILED });
        });
      });
    } else {
      setFormLoader(false);
      Toast({ type: 'error', message: strings.RECAPTCHA_NOT_LOADED });
    }
  }

  useEffect(() => {
    if (clientFormConfig?.logoBase64) {
      const links = document.querySelectorAll("link[rel*='icon']");
      links.forEach(link => link.parentNode.removeChild(link));
      const link = document.createElement('link');
      link.type = 'image/png';
      link.rel = 'icon';
      link.href = clientFormConfig.logoBase64;
      document.head.appendChild(link);
    }
    // eslint-disable-next-line
  }, [clientFormConfig?.logoBase64]);

  return (
    <div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', padding: "2rem" }}>
      {
        formLoader && (
          <div className="form-loader-overlay">
            <Loader />
            <div className="form-loader-backdrop" />
          </div>
        )
      }
      <Helmet>
        <title>{clientFormConfig?.pageName}</title>
      </Helmet>
      <LoadScript
        id={"google-map-script"}
        googleMapsApiKey={GOOGLE_MAP_API_KEY}
        libraries={["places"]}
        onLoad={() => console.log('load')}
        loadingElement={<div style={{ display: 'none' }} />}
      >
        <Card className='border-0 shadow invoice-card-responsive'>
          {clientFormConfig?.logoBase64 && (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: "1rem" }}>
              <img
                src={clientFormConfig.logoBase64}
                alt="Logo"
                style={{ maxWidth: 220, maxHeight: 80, objectFit: 'contain' }}
              />
            </div>
          )}
          <Card.Header as="h3" className="font-weight-bold bg-white border-0 pb-0">{strings.INVOICE_SUBMISSION_TITLE}</Card.Header>
          <Row className='mb-3'>
            <Col>
              <form onSubmit={handleSubmit(handleRecaptchaAndSubmit)}>
                <Card.Body>
                  <div className='cardTitleContainer'>
                    <Card.Title className='business-title mb-3'>
                      {strings.BUSINESS_INFORMATION}
                    </Card.Title>
                    {showFactorCloudOnboardCheckbox && <div className='d-flex align-items-center'>
                      <CheckBox
                        checked={stateOfFCOnboardCheckBox}
                        onChange={(checked) => setStateOfFCOnboardCheckBox(checked)}
                        label={strings.APPLICANT.FACTORCLOUD_ONBOARD_LABEL}
                      />
                    </div>}
                  </div>
                  <RenderBusiness
                    change={change}
                    hideFmcsa={hideFmcsa}
                    setApplicationType={setApplicationType}
                  />
                  <Card.Title className='owners-title mb-3 mt-4'>{strings.OWNER_INFORMATION}</Card.Title>
                  <FieldArray
                    name="owners"
                    component={RenderOwnersFieldArray}
                    props={{ change, formValues: props.formValues }}
                  />
                  <div ref={containerRef}>
                    <Typography variant="h6" style={{ marginTop: '2rem' }}>
                      {strings.CREATE_SIGNATURE}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: '0.5rem' }}>
                      {clientFormConfig?.authorizationText}
                    </Typography>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                      <InfoIcon fontSize="small" style={{ marginRight: 4 }} />
                      <Typography variant="body2">
                        {strings.SIGNATURE_REQUIRED_INFO}
                      </Typography>
                    </div>
                    {/* Show one SignatureCanvas per owner, with heading */}
                    {Array.isArray(props?.formValues?.owners) && props.formValues.owners.length > 0 ? (
                      props.formValues.owners.map((_, idx) => (
                        <div key={idx} style={{ marginBottom: 24 }}>
                          <Typography variant="subtitle1" style={{ marginBottom: 8 }}>{`Owner ${idx + 1} Signature`}</Typography>
                          <SignatureCanvas
                            penColor="black"
                            ref={ref => (signatureRefs.current[idx] = ref)}
                            canvasProps={{
                              width: canvasWidth,
                              height: canvasHeight,
                              className: "sigCanvas",
                            }}
                          />
                          <Button
                            variant="outlined"
                            size="small"
                            style={{ marginTop: 8 }}
                            onClick={() => {
                              if (signatureRefs.current[idx]) signatureRefs.current[idx].clear();
                            }}
                          >
                            {strings.CLEAR}
                          </Button>
                        </div>
                      ))
                    ) : (
                      <div>
                        <Typography variant="subtitle1" style={{ marginBottom: 8 }}>Signature</Typography>
                        <SignatureCanvas
                          penColor="black"
                          ref={(ref) => {
                            sigCanvas = ref;
                          }}
                          canvasProps={{
                            width: canvasWidth,
                            height: canvasHeight,
                            className: "sigCanvas",
                          }}
                        />
                        <Button
                          variant="outlined"
                          style={{ marginBottom: '2rem', marginTop: '1rem' }}
                          onClick={() =>
                            sigCanvas?.clear()
                          }
                        >
                          {strings.CLEAR}
                        </Button>
                      </div>
                    )}
                  </div>
                  <Card.Title className='invoice-title mb-3 mt-4'>{strings.INVOICE}</Card.Title>
                  <div className="mb-4">
                    <FileUploader
                      selectedFiles={selectedFiles}
                      setSelectedFiles={setSelectedFiles}
                      maxSize={MAX_FILE_SIZE}
                      onFilesRejected={(rejectedFiles) => {
                        if (rejectedFiles && rejectedFiles.length > 0) {
                          Toast({ type: 'warning', message: strings.FILE_SIZE_WARNING });
                        }
                      }}
                    />
                  </div>
                  <div>
                    <CheckBox
                      checked={acceptTerms}
                      onChange={setAcceptTerms}
                      label={
                        clientFormConfig?.termsOfServiceURL ? (
                          <span>
                            I accept the <a href={clientFormConfig.termsOfServiceURL} target="_blank" rel="noopener noreferrer">terms and conditions</a>.
                          </span>
                        ) : (
                          <span>{strings.TERMS_AND_CONDITIONS}</span>
                        )
                      }
                    />
                  </div>
                  <div className="d-flex justify-content-center">
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ backgroundColor: '#000', color: '#fff' }}
                      type="submit"
                      disabled={formLoader || !acceptTerms}
                    >
                      {strings.SUBMIT}
                    </Button>
                  </div>
                </Card.Body>
              </form>
            </Col>
          </Row>
        </Card>
      </LoadScript>
    </div>
  )
}


export default reduxForm({
  form: 'applicationForm',
})(InvoiceSubmission)